import type { CSSProperties, ElementType, ReactNode } from 'react';
import { memberPath } from '../lib/routes';
import { LinkUnstyled } from '@leanin/ui';
import type { LinkAsProps } from '@leanin/ui';

type Props = {
  // null → render children without a link wrapper (e.g. tombstoned author).
  userId: string | null | undefined;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  ariaLabel?: string;
  /** Pass `RouterLinkAs` for client-side navigation; omit for a plain `<a>`. */
  linkAs?: ElementType<LinkAsProps>;
  /** For a second, decorative link to the same profile (e.g. the avatar beside
   *  a linked name): hide it from assistive tech and the tab order so the row
   *  offers one stop, not two. */
  decorative?: boolean;
};

export function MemberLink({
  userId,
  children,
  className,
  style,
  ariaLabel,
  linkAs,
  decorative,
}: Props) {
  if (!userId) return <>{children}</>;
  return (
    <LinkUnstyled
      href={memberPath(userId)}
      className={className}
      style={style}
      aria-label={ariaLabel}
      {...(linkAs ? { linkAs } : {})}
      {...(decorative === true ? { tabIndex: -1, 'aria-hidden': true } : {})}
    >
      {children}
    </LinkUnstyled>
  );
}
